/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Event helper class
 **/
define([
	'underscore'
], function(_){

	class EventUtils {

		static SEPARATOR = '\xD7';

		// TODO QueryResultAPI: Remove after
		static toDeprecatedPayload(value) {
			if (!value) {
				return value;
			}

			const useValue = value.value !== undefined ? value.value : value;
			const displayValue = value.label !== undefined ? value.label : useValue;
			let returnValue = {
				u: useValue,
				d: displayValue,
				value: useValue,
				label: displayValue
			};

			if (value.p !== undefined && value.p !== null) {
				returnValue.p = value.p;
			}

			return returnValue;
		}

		/**
		 * Return keys for dataPoints.
		 * @param datapoints Array of data points.
		 */
		static getDataPointKey(dataPoint) {
			var key = '';
			var tempDataPoint = _.clone(dataPoint); //Make a copy to sort and keep dataPoint unchanged.
			var sortedDataPoint = tempDataPoint.sort(EventUtils.compareDataPointKey);
			_.each(sortedDataPoint, function(tuplePart) {
				var u = tuplePart.u || tuplePart;
				key += (u + EventUtils.SEPARATOR);
			});
			return key.slice(0, -1);
		}

		static compareDataPointKey(a, b) {
			if (a.u < b.u) {
				return -1;
			}
			if (a.u > b.u) {
				return 1;
			}
			return 0;
		}

		/**
		 * Return keys for items (datapoint/edge).
		 * @param tuples Array of data points or edge object
		 */
		static getItemKey (tuple) {
			let key;
			if (Array.isArray(tuple)) {
				key = EventUtils.getDataPointKey(tuple);
			} else {
				key = tuple.u || tuple;
			}
			return key;
		}
	}
	return EventUtils;
});
